import './SelectLanguage.scss'

import { SelectContent }         from "@/components/ui/select";
import { SelectItem }            from "@/components/ui/select";
import { SelectRoot }            from "@/components/ui/select";
import { SelectTrigger }         from "@/components/ui/select";
import { SelectValueText }       from "@/components/ui/select";
import { createListCollection }  from '@chakra-ui/react';
import dayjs                     from 'dayjs';
import { setLocale }             from '@widesk-core/locale';
import useMenu                   from '@/hooks/useMenu';
import { useNavigate }           from 'react-router-dom';
import { useParams }             from 'react-router-dom';
import useScreenSize             from '@/hooks/useScreenSize';
import { useTranslation }        from 'react-i18next';
import useTranslations           from '@/hooks/useTranslations';
import NavBarAvatar              from '../navbar/components/NavBarAvatar';

interface ISelectLanguageProps {
	borderColor?: string;
	color?: string;
	heigth?: string;
}

const SelectLanguage = (props: ISelectLanguageProps) => {
	const { borderColor, color } = props;
	const { getCurrentPageKey } = useMenu();
	const pageIsPrivate = getCurrentPageKey()?.type === 'private';
	const { codeValue } = useParams();
	const navigate = useNavigate();
	const { isLG } = useScreenSize();
	const { t, i18n } = useTranslation();
	const { getNavigationTranslation } = useTranslations();

	const languages = createListCollection({
		items: [
			{ label: isLG ? t('app.languages.fr') : 'Fr', value: 'fr' },
		  	{ label: isLG ? t('app.languages.en') : 'En', value: 'en' },
		],
	})

	return (
		<SelectRoot 
			className={`select-language ${isLG ? 'lg' : 'xs'} ${pageIsPrivate ? 'private' : ''}`}
			collection={languages}
			defaultValue={[i18n.language]}
			onValueChange={(option) => {
				const value = option.value[0] as ('en' | 'fr');
				if (value) {
					setLocale(value);
					i18n.changeLanguage(value);
					dayjs.locale(value);
					
					const currentPageKey = getCurrentPageKey();

					if (currentPageKey) {
						const to = codeValue ? `${getNavigationTranslation(currentPageKey.label, 'path')}/${codeValue}` : getNavigationTranslation(currentPageKey.label, 'path');
						navigate(to);
					}

				}
			}}
			color={color}
			width="fit-content"
			border={isLG ? `1.5px solid ${borderColor}` : "unset"}
			borderRadius="8px"
			size="md"
		>
			<SelectTrigger>
				{
					!pageIsPrivate || isLG
					? (
						<SelectValueText maxWidth="100%" paddingRight="25px" paddingLeft="10px" />
					)
					: (
						<NavBarAvatar />
					)
				}
				
			</SelectTrigger>
			<SelectContent>
				{languages.items.map((language) => (
					<SelectItem 
						cursor="pointer"
						item={language} 
						key={language.value}
						_hover={{ backgroundColor: '#DEDEDE' }}
					>
						{language.label}
					</SelectItem>
				))}
			</SelectContent>
		</SelectRoot>
	)
}

export default SelectLanguage;